import { render } from "./AuditLogsManagement.vue?vue&type=template&id=b1d00f88&scoped=true"
import script from "./AuditLogsManagement.vue?vue&type=script&lang=js"
export * from "./AuditLogsManagement.vue?vue&type=script&lang=js"

import "./AuditLogsManagement.vue?vue&type=style&index=0&id=b1d00f88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1d00f88"]])

export default __exports__